// extracted by mini-css-extract-plugin
export default {"title":"ForthBox_title__aT9B8","faq":"ForthBox_faq__oWZc0","forthBox":"ForthBox_forthBox__SSrcn","irluxeinstagram":"ForthBox_irluxeinstagram__wEkLF"};